// extracted by mini-css-extract-plugin
module.exports = {"container-expression":"loyaltyCard_container-expression__1z4ux","equal-sign":"loyaltyCard_equal-sign__2bxkX"};